import { render, staticRenderFns } from "./provenances.vue?vue&type=template&id=6b5b7a28&"
import script from "./provenances.vue?vue&type=script&lang=js&"
export * from "./provenances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports